export * from './assignment-status.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/assignment-status/index.ts